import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { Typography } from "components/atoms";
import {
  NavLeftArrow,
  NavLeftArrowOnbForm,
  NavRightArrow,
  NavRightArrowOnbForm,
} from "components/atoms/Icon";
import { useScreenSize } from "hooks";
import "./index.scss";

interface IProps {
  incrementMonth: () => void;
  decrementMonth: () => void;
  text: string;
  isLeftDisable?: boolean;
  isRightDisable?: boolean;
  setIsMonthPopUpShow?: Dispatch<SetStateAction<boolean>>;
  setIsYearPopUpShow?: Dispatch<SetStateAction<boolean>>;
  popUpIncrementMonth?: (month: number) => void;
  popUpIncrementYears?: (year: number) => void;
  isMonthPopUpShow?: boolean;
  isYearPopUpShow?: boolean;
  maxDate?: any;
  minDate?: any;
  currentMonth?: any;
  theme?: "light" | "dark";
}

export const MonthNavigatorOnboardingForm = ({
  incrementMonth,
  decrementMonth,
  text,
  isLeftDisable,
  isRightDisable,
  setIsMonthPopUpShow,
  setIsYearPopUpShow,
  popUpIncrementMonth,
  popUpIncrementYears,
  isMonthPopUpShow,
  isYearPopUpShow,
  maxDate,
  minDate,
  currentMonth,
  theme,
}: IProps) => {
  const screen = useScreenSize();

  const monthYearPopupRef = useRef<any>(null);

  const setYearPopUpShow = () => {
    if (screen.width > 575) {
      setIsYearPopUpShow && setIsYearPopUpShow((prev) => !prev);
      setIsMonthPopUpShow && setIsMonthPopUpShow((prev) => false);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      monthYearPopupRef.current &&
      !monthYearPopupRef.current.contains(event.target as Node)
    ) {
      setIsMonthPopUpShow && setIsMonthPopUpShow(false);
      setIsYearPopUpShow && setIsYearPopUpShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="month-year-navigator-section-onb-form">
      <Typography
        variant="h4Med"
        styles="month-and-year-onb-form-style"
        label={text}
        onClick={setYearPopUpShow}
      />
      <div className="arrow-wrapper-onb-form">
        <NavLeftArrowOnbForm
          theme={theme}
          onClick={decrementMonth}
          style={
            isLeftDisable ? "disable-nav-arrow-onb-form" : "nav-arrow-onb-form"
          }
          isDisable={isLeftDisable}
        />
        <NavRightArrowOnbForm
          theme={theme}
          onClick={incrementMonth}
          style={
            isRightDisable ? "disable-nav-arrow-onb-form" : "nav-arrow-onb-form"
          }
          isDisable={isRightDisable}
        />
      </div>
    </div>
  );
};
